/**
 * Account-TrackingInfo Queries
 */
import gql from 'graphql-tag'

export const getTrackingInfoUpsQuery = gql`
  query GetTrackingInfo($code: String!) {
    trackingInfo: getTrackingInfo(code: $code, carrier: "ups")
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TrackingInfoUps/data.ts